import Link from "next/link";

import type { TaggedRecipe } from "../../_types/content";
import StorefrontMedia from "./StorefrontMedia";
import { Action, TagList } from "./ui/Primitives";
import { CardTemplate } from "./ui/Templates";

export default function RecipeLinkCard({
  recipe,
  presentation = "catalog",
  borderless = false,
}: {
  recipe: TaggedRecipe;
  presentation?: "catalog" | "carousel";
  borderless?: boolean;
}) {
  const isCarousel = presentation === "carousel";

  return (
    <CardTemplate
      presentation={presentation}
      bordered={!borderless}
      media={
        <Link
          href={`/test/recipes/${recipe.slug}`}
          aria-label={`View ${recipe.title} recipe`}
          className="block h-full overflow-hidden bg-clay"
        >
          <StorefrontMedia
            image={recipe.cardImage}
            sizes={
              isCarousel
                ? "(min-width: 1024px) 24vw, (min-width: 640px) 37vw, 71vw"
                : "(min-width: 1536px) 16vw, (min-width: 1280px) 20vw, (min-width: 640px) 30vw, 100vw"
            }
            className="!aspect-square transition-transform duration-500 hover:scale-[1.02]"
          />
        </Link>
      }
    >
        <h3
          className={`${isCarousel ? "text-fluid-base" : "text-xl"} font-neueheitz leading-[1.05]`}
        >
          <Link
            href={`/test/recipes/${recipe.slug}`}
            className="hover:underline hover:underline-offset-4"
          >
            {recipe.title}
          </Link>
        </h3>
        <p className={`${isCarousel ? "text-lg" : "text-base"} pt-2 font-[700]`}>
          {recipe.prepMinutes + recipe.cookMinutes} minutes · Serves {recipe.servings}
        </p>
        <p className={`${isCarousel ? "text-base" : "text-sm"} pt-2 leading-snug text-earth`}>
          {recipe.summary}
        </p>

        <TagList
          items={recipe.tagLabels}
          limit={3}
          label="Recipe grains"
          className={isCarousel ? "pt-4 text-sm" : "pt-3 text-xs [&_span]:px-2 [&_span]:py-0.5"}
        />

        <div className={`mt-auto ${isCarousel ? "pt-6" : "pt-4"}`}>
          <Action
            href={`/test/recipes/${recipe.slug}`}
            size={isCarousel ? "medium" : "small"}
            className="block w-full text-center"
          >
            View Recipe
          </Action>
        </div>
    </CardTemplate>
  );
}
